const STORAGE_KEY = 'waf-crm-locale';

export type AppLocale = 'uk' | 'en';

export function loadLocale(): AppLocale {
  const value = window.localStorage.getItem(STORAGE_KEY);
  return value === 'en' ? 'en' : 'uk';
}

export function saveLocale(locale: AppLocale): void {
  window.localStorage.setItem(STORAGE_KEY, locale);
}
